import { ApolloConsumer } from "react-apollo";
import { Redirect } from "react-router-dom";
;

export default () => (
  <ApolloConsumer>
    {(client) => {
      client.resetStore();
      localStorage.setItem("qSession", "");
      return <Redirect to="/Login" />;
    }}
  </ApolloConsumer>
);
